import React, { useCallback } from 'react';

import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';

import ArrowBackIosFilled from '@mui/icons-material/ArrowBackIos';

import {
  Form,
  useCreate,
  useNotify,
} from 'react-admin';
import { useNavigate } from 'react-router-dom';

import { FieldValues } from 'react-hook-form';

import conflictFieldsMap from './conflictFieldsMap';
import conflictFieldsValidationMap from './conflictFieldsValidationMap';
import cleaner from '../../utilities/dataProvider/cleaner';
import useConflictContext from './useConflictContext';

const ConflictResolutionManualInput = () => {
  const [create] = useCreate();

  const notify = useNotify();
  const navigate = useNavigate();

  const {
    searchParams,
    name,
    identificationInfo,
    entityId,
    entityType,
  } = useConflictContext();

  const handleClose = useCallback(() => {
    navigate(`..?${searchParams.toString()}`);
  }, [navigate, searchParams]);

  const handleSubmit = useCallback((data: FieldValues) => {
    create('data-points', {
      data: {
        entity: {
          id: entityId,
          type: entityType,
        },
        name,
        value: cleaner(data.value),
        comment: data.comment,
        type: 'manual',
        identificationInfo,
        selected: true,
      },
    }, {
      onSuccess: () => {
        handleClose();
      },
      onError: () => {
        notify('Could not save manual input. If the problem persists, reach out to our support.', { type: 'error' });
      },
    });
  }, [create, handleClose, entityId, name, identificationInfo, notify, entityType]);

  return (
    <Grid container gap={1}>
      <Grid
        mb={3}
        size={12}
      >
        <Box display="flex" alignItems="center">
          <IconButton size="medium" onClick={handleClose}>
            <ArrowBackIosFilled fontSize="medium" color="primary" />
          </IconButton>
          <Typography color="primary" variant="h5">Back</Typography>
        </Box>
      </Grid>
      <Grid size={12}>
        <Card sx={{ m: 0 }} variant="outlined">
          <CardContent>
            <Form
              onSubmit={handleSubmit}
              resolver={conflictFieldsValidationMap[name]}
              record={{}}
            >
              <Grid container spacing={6}>
                <Grid size={12}>
                  {React.createElement(conflictFieldsMap[name])}
                </Grid>
                <Grid
                  display="flex"
                  justifyContent="center"
                  size={12}
                >
                  <Box display="flex" gap={8}>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button variant="contained" type="submit">Save</Button>
                  </Box>
                </Grid>
              </Grid>
            </Form>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ConflictResolutionManualInput;
